<div class="container">

  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Get In Touch</h2>

  <div class="spacer-60"></div>

  <div class="row">

      <!-- contact info -->
      <div class="col-12 contact-info">
        <h3 class="wow fadeInUp">Ask for support, or let's just talk about everything!</h3>
        <p class="wow fadeInUp">The best place to reach me is LinkedIn chat or my support email, feel free to connect and send me a message.</p>
        <div class="contact-buttons wow fadeInUp">
          <a href="https://www.linkedin.com/in/davide-gena/" target="_blank" rel="noopener noreferrer" class="linkedin-btn">
            <i class="fab fa-linkedin word-glow"></i><span class="word-glow">Connect on LinkedIn</span>
          </a>
          <a href="mailto:dg.dev.laboratory@gmail.com" class="linkedin-btn">
            <i class="fas fa-envelope word-glow"></i><span class="word-glow">Email me</span>
          </a>
        </div>
      </div>

  </div>

</div>
